import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const MODEL_PATH = "/sorteo/";

export const getParticipantes = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "participantes");
  return handleResponse(response);
};

export const deleteParticipantes = async () => {
  const response = await HTTP_REQUEST.delt(MODEL_PATH);
  return handleResponse(response);
};

export const makeSorteo = async (body) => {
  const response = await HTTP_REQUEST.post(MODEL_PATH + "go", body);
  return handleResponse(response);
};

export const getGanadores = async (codigo) => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "ganadores/", codigo);
  return handleResponse(response);
};

export const downloadExcelGanadores = async (codigo) => {
  const response = await HTTP_REQUEST.getFile(MODEL_PATH + "download/" + codigo);
  return response; // return a blob
};

export const getSorteos = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH);
  return handleResponse(response);
};

export const updateOne = async (body, recordId) => {
  const response = await HTTP_REQUEST.put(MODEL_PATH, body, recordId);
  return handleResponse(response);
};

export const updateByCodigo = async (body, codigo) => {
  const response = await HTTP_REQUEST.put(MODEL_PATH + "codigo/", body, codigo);
  return handleResponse(response);
};

export const getSorteosPublic = async () => {
  const response = await HTTP_REQUEST.post(MODEL_PATH + "public");
  return handleResponse(response);
};

export const getGanadoresPublic = async (codigo) => {
  const response = await HTTP_REQUEST.post(MODEL_PATH + "public/ganador", { codigo });
  return handleResponse(response);
};
